import Head from 'next/head';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import { useSetSelectedNav } from '@stores/sidenav';
import { UPCOMING_BATCHES } from '@constants/segment';
import setupInitialProps from '@utils/setupInitialProps';
import BatchesGroupListing from '@cont/SeeAll/BatchesGroupListing';
import plusNavBarItems from '@layout/NavBar/PlusNavBar/plusNavBarItems';
import { isBatchSubscriptionActive } from '@selectors/auth';
import { DEFAULT_QUERY_TYPE } from '@cont/BatchGroup/constants';
import Layout from '@layout/index';
import { fetchPlatformUpcomingFilters } from '@api/fetchers/platformBatchGroup';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const UpcomingBatchesPage = ({
  goalInfo,
  hasSideBar,
  filterOptions,
  queryType
}) => {
  const { title, name } = goalInfo || {};
  const metaTitle = `Upcoming batches | ${title} | Unacademy`;
  useSetSelectedNav(plusNavBarItems.UPCOMING_BATCHES);
  return (
    <>
      <NextSeo
        title={metaTitle}
        openGraph={{
          title: metaTitle
        }}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <BatchesGroupListing
        name={name}
        hasSideBar={hasSideBar}
        page={UPCOMING_BATCHES}
        filterOptions={filterOptions}
        queryType={queryType}
      />
    </>
  );
};

UpcomingBatchesPage.pageInfo = {
  isMWebSupported: true,
  name: UPCOMING_BATCHES,
  layoutOptions: {
    hideSearch: true,
    hideFooter: true
  }
};

export default UpcomingBatchesPage;

UpcomingBatchesPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID, type = DEFAULT_QUERY_TYPE } = query;
    let filterOptions = [];
    const state = store.getState();
    const isSubscriptionActive = isBatchSubscriptionActive(state, goalUID);
    UpcomingBatchesPage.pageInfo.layoutOptions.showPlusNav =
      isSubscriptionActive;
    const response = await fetchPlatformUpcomingFilters();
    if (response.errorCode) {
      filterOptions = [];
    } else {
      filterOptions = response;
    }
    return {
      isServer,
      goalInfo: store.getState().topologies.data[goalUID],
      hasSideBar: isSubscriptionActive,
      filterOptions,
      queryType: type
    };
  },
  UpcomingBatchesPage.pageInfo
);

UpcomingBatchesPage.propTypes = {
  goalInfo: PropTypes.objectOf(PropTypes.any).isRequired
};
UpcomingBatchesPage.Layout = Layout;
UpcomingBatchesPage.Wrapper = PageReduxProvider;
